export default __webpack_public_path__ + "static/media/salud.ebb5198c.svg";